module.exports = __webpack_public_path__ + "media/images/favicons/apple-touch-icon-180x180-a51eee8dfec4edf2ae5d695ac4284eb3.png";